import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from '../constants/GetOrganisationsConstant';

var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
var assign = require('object-assign');

var response = {};
var activeResponse = {};

function parseResponse(resp) {
    response = resp;
}

function parseActiveOrgs(resp) {
    activeResponse = resp
}

var GetOrganisationsStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    },
    getActiveOrgsResponse: function () {
        return activeResponse;
    }
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.GET_ORGANISATIONS_RESPONSE:
            var resp = action.data;
            parseResponse(resp)
            GetOrganisationsStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
            break;
        case Constants.GET_ACTIVE_ORGANISATIONS_RESPONSE:
            var res = action.data;
            parseActiveOrgs(res)
            GetOrganisationsStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
            break;

        default:
    }
});

export default GetOrganisationsStore;